// Shared motion language tokens. Tuned for a "sleek, modern, pro" feel —
// short, decisive transitions with minimal overshoot. Every animation
// component in `~components/shared/motion` references these tokens so
// timing/feel can be adjusted in one place.

const MS_TO_S = 1 / 1000

const MOTION_DURATION_MS = {
    quick: 140,
    base: 220,
    slow: 360,
} as const

export const MOTION_DURATION_S = {
    quick: MOTION_DURATION_MS.quick * MS_TO_S,
    base: MOTION_DURATION_MS.base * MS_TO_S,
    slow: MOTION_DURATION_MS.slow * MS_TO_S,
} as const

// Cubic-bezier curves. `decel` for entrances, `accel` for exits,
// `emphasized` for hero moments that should feel confident.
export const MOTION_EASE = {
    standard: [0.4, 0, 0.2, 1],
    decel: [0, 0, 0.2, 1],
    accel: [0.4, 0, 1, 1],
    emphasized: [0.2, 0, 0, 1],
} as const

// Spring presets — biased toward stiff+damped for a pro/SaaS feel.
export const MOTION_SPRING = {
    snappy: { type: "spring", stiffness: 380, damping: 30, mass: 0.9 },
    soft: { type: "spring", stiffness: 220, damping: 26, mass: 1 },
    gentle: { type: "spring", stiffness: 140, damping: 22, mass: 1 },
} as const
